import { ChangeDetectorRef, Component, Directive, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import moment from 'moment';
import { Moment } from 'moment';
import { YEAR_FORMAT, YearFormat } from '../orders/order/order.component';
import { DepartmentsSummaryComponent } from './departments-summary/departments-summary.component';
import { ConsultantRankingComponent } from './consultant-ranking/consultant-ranking.component';
import { MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { Department } from '../models/department.model';
import { DepartmentService } from '../services/department.service';

@Component({
    selector: 'app-dashboard',
    imports: [
        MatFormFieldModule,
        MatDatepickerModule,
        ReactiveFormsModule,
        FormsModule,
        MatInputModule,
        MatSlideToggleModule,
        MatSelectModule,
        DepartmentsSummaryComponent,
        ConsultantRankingComponent,
        YearFormat
    ],
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true, strict: false } },
    ]
})
export class DashboardComponent implements OnInit {
  public year: Date = moment.utc().toDate();
  public includePipeline: boolean = false;
  public selectedDepartmentId: string | null = null;
  public departments: Department[] = [];

  constructor(
    private cd: ChangeDetectorRef,
    private departmentService: DepartmentService,
  ) {

  }

  async ngOnInit(): Promise<void> {
    const all = await this.departmentService.list();
    this.departments = all
      .filter(d => d.includedInDashboard)
      .sort((a, b) => (a.name ?? '').localeCompare(b.name ?? '', 'da'));
  }

  async setYear(normalizedMonthAndYear: Moment | any, datepicker: MatDatepicker<Date>) {
    if (datepicker) {
      datepicker.close();
    }

    if (!moment.isMoment(normalizedMonthAndYear) && normalizedMonthAndYear?.value) {
      normalizedMonthAndYear = moment(normalizedMonthAndYear.value, "YYYY", false);
    }

    if (!moment.isMoment(normalizedMonthAndYear)) {
      return;
    }

    setTimeout(async () => {
      let year = normalizedMonthAndYear.add(12, "hours").toDate();

      this.year = year;
      this.cd.detectChanges();
    });
  }
}
